import type { PixelSprite } from '../types.js';
import { sprites as autumnWreath } from './autumnWreath.js';
import { sprites as barrel } from './barrel.js';
import { sprites as campfire } from './campfire.js';
import { sprites as cart } from './cart.js';
import { sprites as cherryPetals } from './cherryPetals.js';
import { sprites as christmasTree } from './christmasTree.js';
import { sprites as cobblePath } from './cobblePath.js';
import { sprites as crocus } from './crocus.js';
import { sprites as fallenLeaves } from './fallenLeaves.js';
import { sprites as fireflies } from './fireflies.js';
import { sprites as firewood } from './firewood.js';
import { sprites as flag } from './flag.js';
import { sprites as flowerBed } from './flowerBed.js';
import { sprites as hammock } from './hammock.js';
import { sprites as hotDrink } from './hotDrink.js';
import { sprites as iceCreamCart } from './iceCreamCart.js';
import { sprites as icicle } from './icicle.js';
import { sprites as jangseung } from './jangseung.js';
import { sprites as lantern } from './lantern.js';
import { sprites as leafSwirl } from './leafSwirl.js';
import { sprites as lemonade } from './lemonade.js';
import { sprites as puddle } from './puddle.js';
import { sprites as rainPuddle } from './rainPuddle.js';
import { sprites as rake } from './rake.js';
import { sprites as signpost } from './signpost.js';
import { sprites as sled } from './sled.js';
import { sprites as smoke } from './smoke.js';
import { sprites as snowdrift } from './snowdrift.js';
import { sprites as snowman } from './snowman.js';
import { sprites as sotdae } from './sotdae.js';
import { sprites as sprinkler } from './sprinkler.js';
import { sprites as torch } from './torch.js';
import { sprites as tulip } from './tulip.js';
import { sprites as tulipField } from './tulipField.js';
import { sprites as umbrella } from './umbrella.js';
import { sprites as wateringCan } from './wateringCan.js';
import { sprites as winterLantern } from './winterLantern.js';
import { sprites as woodpile } from './woodpile.js';
export const sprites: Readonly<Record<string, readonly PixelSprite[]>> = {
  autumnWreath,
  barrel,
  campfire,
  cart,
  cherryPetals,
  christmasTree,
  cobblePath,
  crocus,
  fallenLeaves,
  fireflies,
  firewood,
  flag,
  flowerBed,
  hammock,
  hotDrink,
  iceCreamCart,
  icicle,
  jangseung,
  lantern,
  leafSwirl,
  lemonade,
  puddle,
  rainPuddle,
  rake,
  signpost,
  sled,
  smoke,
  snowdrift,
  snowman,
  sotdae,
  sprinkler,
  torch,
  tulip,
  tulipField,
  umbrella,
  wateringCan,
  winterLantern,
  woodpile,
};
